import styled from "styled-components";
import { Select } from "antd";
import { StyledSelectProps } from "./types";

export const StyledSelect = styled(Select)<StyledSelectProps>`
  width: ${(p) => {
    if (p.width === undefined || p.width === null) return "100%";
    if (typeof p.width === "string") return p.width;
    return `${p.width}px`;
  }} !important;
  
  /* Set height on the main select component */
  &.ant-select {
    height: ${(p) => p.height || 36}px !important;
  }
  
  /* Target the selector with higher specificity */
  .ant-select-selector {
    border-radius: ${(p) => p.borderRadius || 8}px !important;
    height: ${(p) => `${p.height || 36}px`} !important;
    min-height: ${(p) => `${p.height || 36}px`} !important;
    max-height: ${(p) => `${p.height || 36}px`} !important;
    padding: 0 11px !important;
    display: flex !important;
    align-items: center !important;
    box-sizing: border-box !important;
    background-color: ${(p) => (p.theme === "dark" ? "#1a202c" : "#fff")} !important;
    border: 1px solid ${(p) => (p.theme === "dark" ? "#718096" : "#d9d9d9")} !important;
    color: ${(p) => (p.theme === "dark" ? "#fff" : "inherit")} !important;
  }

  &:hover .ant-select-selector {
    background-color: ${(p) => (p.theme === "dark" ? "#1a202c" : "#fff")} !important;
    border-color: ${(p) => (p.theme === "dark" ? "#718096" : "#d9d9d9")} !important;
  }

  &.ant-select-focused .ant-select-selector,
  &:focus .ant-select-selector {
    background-color: ${(p) => (p.theme === "dark" ? "#1a202c" : "#fff")} !important;
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }

  &.ant-select-open .ant-select-selector {
    background-color: ${(p) => (p.theme === "dark" ? "#1a202c" : "#fff")} !important;
  }
  
  /* Style the selection item */
  .ant-select-selection-item {
    line-height: ${(p) => (p.height || 36) - 2}px !important;
    height: auto !important;
    display: flex !important;
    align-items: center !important;
  }
  
  /* Style the placeholder */
  .ant-select-selection-placeholder {
    line-height: ${(p) => (p.height || 36) - 2}px !important;
    height: auto !important;
    display: flex !important;
    align-items: center !important;
    color: ${(p) => (p.theme === "dark" ? "#8c8c8c" : "#bfbfbf")} !important;
  }
  
  /* Style the search input */
  .ant-select-selection-search {
    height: 100% !important;
    line-height: ${(p) => (p.height || 36) - 2}px !important;
    
    .ant-select-selection-search-input {
      height: 100% !important;
      line-height: ${(p) => (p.height || 36) - 2}px !important;
    }
  }
  
  /* Ensure the selection render area has proper height */
  .ant-select-selection__rendered {
    line-height: ${(p) => (p.height || 36) - 2}px !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }
  
  /* Dropdown menu styles */
  .ant-select-dropdown {
    border-radius: 12px !important;
    padding: 8px !important;
    box-shadow: ${(p) => (p.theme === "dark" ? "0 4px 12px rgba(0, 0, 0, 0.5)" : "0 4px 12px rgba(0, 0, 0, 0.15)")} !important;
    background: ${(p) => (p.theme === "dark" ? "#1a202c" : "#fff")} !important;
  }
  
  /* Dropdown menu item styles */
  .ant-select-item {
    border-radius: 8px !important;
    padding: 10px 12px !important;
    margin: 4px 0 !important;
    transition: all 0.2s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    
    /* Unselected item styles */
    color: ${(p) => (p.theme === "dark" ? "#fff" : "#262626")} !important;
    background-color: transparent !important;
    border: none !important;
    
    /* Hover state for unselected items */
    &:hover:not(.ant-select-item-option-selected) {
      background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#E6F4FF")} !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
    }
    
    /* Selected item styles */
    &.ant-select-item-option-selected {
      background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#E6F4FF")} !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
      font-weight: 500 !important;
      
      &:hover {
        background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#BAE0FF")} !important;
        color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
      }
    }
    
    /* Active/focus state */
    &.ant-select-item-option-active:not(.ant-select-item-option-selected) {
      background-color: ${(p) => (p.theme === "dark" ? "#4a5568" : "#E6F4FF")} !important;
      color: ${(p) => (p.theme === "dark" ? "#fff" : "#2D6CCA")} !important;
    }
  }
  
  /* Remove default Ant Design item padding adjustments */
  .ant-select-item-option-content {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }
`;


